/* eslint-disable max-len */
import { MESSAGE_NUMBER_WORD_MAP } from './constants';

// dropZeros removes decimals if price has no cents
// dropZeros:true  = 239 -> $239 || 239.23 -> $239.23
// dropZeros:false = 239 -> $239.00 || 239.23 -> $239.23
export const formatPrice = (price, dropZeros) => {
  if (price == null || price <= 0) { return ''; }
  if (price < 1 && price !== 0) { return `${(price * 100).toFixed()}¢`; }
  if (dropZeros && price % 1 === 0) { return `$${parseFloat(price)}`; }
  return `$${parseFloat(price).toFixed(2)}`;
};

export const formattedReward = ({
  rewardVal
}, dropZeros, rewardType) => {
  if (rewardType === 'PERCNTOFF') { return `${rewardVal}%`; }
  return formatPrice(rewardVal, dropZeros);
};

export const toWord = (num) => {
  return MESSAGE_NUMBER_WORD_MAP[num] || num;
};

export const analyticsPromoClickEvent = () => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('promotion.click');
  }
};

export const triggerNewRelicEvent = (props) => {
  try {
    if (typeof window !== 'undefined' && window?.newrelic) {
      window.newrelic.addPageAction(
        props.actionName,
        {
          component: 'Promotion',
          ...props.customAttributes
        }
      );
    }
  } catch (err) {
    console.error(`NewRelic event logging failed for ${props.actionName}`, err);
  }
};

export const setProductImpressionData = (itemId, data) => {
  try {
    if (typeof window?.digitalData !== 'undefined') {
      if (!window?.digitalData?.content) {
        window.digitalData.content = {};
        window.digitalData.content.product = [];
      }
      const objIndex = window.digitalData.content.product.findIndex((obj) => obj?.productInfo?.sku === itemId);
      if (objIndex >= 0) {
        if (!window.digitalData.content.product[objIndex].productInfo) {
          window.digitalData.content.product[objIndex].productInfo = {};
        }
        if (!window.digitalData.content.product[objIndex].productInfo.badge) {
          window.digitalData.content.product[objIndex].productInfo.badge = [];
        }
        const haveBadge = window.digitalData.content.product[objIndex].productInfo.badge.some((badge) => badge?.name === data?.name);
        if (!haveBadge) {
          window.digitalData.content.product[objIndex].productInfo.badge.push(data);
        }
      }
    }
  } catch (err) {
    console.error('Error setting product impression data:', err);
  }
};
